<template>
  <div class="bb-popup-list" ref="bbPopupList">
    <div class="bb-popup-list__item"
         @click.stop="clickItem(option)"
         v-for="option in options"
         :key="option"
    >
      {{option}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupList',
  props: ['options'],
  methods: {
    clickItem (item) {
      this.$emit('clickItem', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-popup-list {
    position: absolute;
    min-width: 134px;
    border-radius: 8px;
    background-color: $color-white;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
    padding: 16px 16px;

    &__item {
      font-weight: normal;
      font-size: 15px;
      line-height: 18px;
      padding-bottom: 16px;
      color: $color-black;
      cursor: pointer;
      transition: .3s;

      &:hover {
        color: $color-accent-hover;
      }

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/PopupList/PopupList.vue